var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_25_1427",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_25_1427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5001 11.8125C13.5001 13.1125 13.0439 14.2188 12.1314 15.1313C11.2189 16.0438 10.1126 16.5 8.81262 16.5C7.51262 16.5 6.40637 16.0438 5.49387 15.1313C4.58137 14.2188 4.12512 13.1125 4.12512 11.8125V4.875C4.12512 3.9375 4.45325 3.14062 5.1095 2.48438C5.76575 1.82812 6.56262 1.5 7.50012 1.5C8.43762 1.5 9.2345 1.82812 9.89075 2.48438C10.547 3.14062 10.8751 3.9375 10.8751 4.875V11.4375C10.8751 12.0125 10.6751 12.5 10.2751 12.9C9.87512 13.3 9.38762 13.5 8.81262 13.5C8.23762 13.5 7.75012 13.3 7.35012 12.9C6.95012 12.5 6.75012 12.0125 6.75012 11.4375V4.5H8.25012V11.4375C8.25012 11.6 8.30325 11.7344 8.4095 11.8406C8.51575 11.9469 8.65012 12 8.81262 12C8.97512 12 9.1095 11.9469 9.21575 11.8406C9.322 11.7344 9.37512 11.6 9.37512 11.4375V4.875C9.36262 4.35 9.17825 3.90625 8.822 3.54375C8.46575 3.18125 8.02512 3 7.50012 3C6.97512 3 6.53137 3.18125 6.16887 3.54375C5.80637 3.90625 5.62512 4.35 5.62512 4.875V11.8125C5.61262 12.7 5.91887 13.4531 6.54387 14.0719C7.16887 14.6906 7.92512 15 8.81262 15C9.68762 15 10.4314 14.6906 11.0439 14.0719C11.6564 13.4531 11.9751 12.7 12.0001 11.8125V4.5H13.5001V11.8125Z",
    fill: "#B4B4B4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.c88ff4e9aa9c9ef2cadb9d66a2d5e60d.svg";
export { ForwardRef as ReactComponent };